import { Categories } from './Categories';
import { Languages } from './Languages';
import { Search } from './Search';
import { Templates } from './Templates';
import { Container } from './styled';
export function Filters() {
    return (<Container>
      <Search />
      <Templates />
      <Categories />
      <Languages />
    </Container>);
}
